import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { AppMessageService } from './hms.service';

import { AppNoRecordsViewComponent } from './no-records.component/index';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    AppNoRecordsViewComponent,
  ],
  exports: [
    AppNoRecordsViewComponent,
  ],
  providers: [AppMessageService],
})
export class SharedModule { }



// WEBPACK FOOTER //
// /ng-app/src/shared/shared.module.ts